// components/Stepper.js
import React from "react";
import "./Stepper.scss";
interface StepperProps{
  currentStep:number,
  goToStep:(index:number)=>void;
  isNextDisabled:boolean;
}
export const steps = [
  "Basic Details",
  "Power Position",
  "Sales Rep Classification",
  "Target Value",
  "Plan Negotiation Actions",
];
export const totalSteps = steps.length;

const Stepper = ({ currentStep,goToStep,isNextDisabled }: StepperProps) => {

  return (
    <div className="stepper-container">
      <div className="stepper-steps">
        {steps.map((step, index) => {
          const isClickable= index< currentStep ;
          return(
            <div className="step" key={step}>
            {index < steps.length - 1 && (
              <div
                className={`step-line ${index < currentStep ? "completed-line" : ""
                  }`}
              ></div>
            )}
            <button
              className={`step-circle 
              ${index < currentStep ? "completed" : ""}
              ${index === currentStep ? "step-circle-active" : ""}
              ${index !==currentStep ? "clickable-step":""}
              `} onClick={()=>isClickable && goToStep(index)}
            ></button>
            <div
              className={`step-label ${index === currentStep ? "active" : ""}`}
            >
              {step}
            </div>
          </div>
          );
        })}
      </div>
    </div>
  );
};

export default Stepper;
